import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Seguimiento/savePrimerSeguimientoDelPool`, method: 'POST', body: values, token: token})
}
